<template>
    <divided-section 
        id="sek-section">
        <template v-slot:right-section>
            <h2 class="sek-section-title">
                Buscando sempre <br>
                as melhores opções <br>
                de negócios lucrativos<br>
                aos nossos Assesorados
            </h2>

            <circular-button
                @click="goTo({name: 'parceiro'})"
                class="sek-section-login-btn white--text">
                Login
            </circular-button>
        </template>
    </divided-section>
</template>

<script>
import DividedSection from "@/components/structure/DividedSection"
import CircularButton from "@/components/utils/CircularButton"

export default {
    components: {
        "divided-section": DividedSection,
        "circular-button": CircularButton
    },
    methods: {
        goTo(opts) {
            this.$router.push(opts)
        }
    }
}
</script>

<style lang="scss">
#sek-section {
    min-height: 973px;
    height: 973px;

    .left-section {
        background-image: url('~@/assets/images/sek-section-bg.png');
    }

    .right-section {
        padding-top: 235px;

        .sek-section-title {
            white-space: pre-line;
            font-size: 45px;
            line-height: 50px;
            color: $c-white;
            margin-bottom: 60px;
        }

        .sek-section-login-btn {
            background-color: $c-secondary;
            width: 160px;
        }
    }
}

@media screen and (max-width: 480px) {
    #sek-section {
        height: auto;
        min-height: unset;

        .left-section {
            display: none;
        }

        .right-section {
            padding-top: 150px;
            padding-bottom: 80px;
        }
        
    }
}
</style>